import { base } from './base/base.js';
import './error/error.scss';
import './favicon/favicon.js';

export function layout() {
  base();
}
